export { Slider } from './slider/slider';
export { RangeSlider } from './range-slider/range-slider';
export type { SliderProps, SliderStylesNames } from './slider/slider';
export type { RangeSliderProps } from './range-slider/range-slider';
